export default class IconItem {
    name: string;
    icon: string;
    select: (() => void);
    deselect: (() => void);
    hide: (() => void);
    otherIcons: IconItem[];
    shouldShow: boolean;
    enabled: boolean;
    selected: boolean;
    hideMenu: (() => void) | undefined;
    button: HTMLButtonElement | undefined;
    translation: string;

    constructor(name: string, icon: string, description: string, select: (() => void), deselect: (() => void), otherIcons: IconItem[], shouldShow: boolean = true, enabled: boolean = true, selected: boolean = false) {
        this.name = name;
        this.icon = icon;
        this.select = (() => {
            this.selected = true;
            if (this.button) this.button.classList.add("tbdc-icon-menu-icon-selected");
            select();
        });

        this.hide = (() => {
            this.deselect();
            if (this.hideMenu) {
                this.hideMenu();
            }
        })
        this.deselect = (() => {
            this.selected = false;
            if (this.button) this.button.classList.remove("tbdc-icon-menu-icon-selected");
            deselect();
        });
        this.otherIcons = otherIcons;
        this.shouldShow = shouldShow;
        this.enabled = enabled;
        this.selected = selected;
        this.translation = "message." + description;
    }

    public static GetDissabled() {
        return new IconItem("icon-item-dissabled", "", "", () => { }, () => { }, [], false, false)
    }


    public equals(other: IconItem): boolean {
        return this.name == other.name;
    }
}